module.exports = __webpack_public_path__ + "static/img/baojingqueren2.8f91def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/baojingqueren2.png
// module id = SGcm
// module chunks = 24